import { Schema } from "effect";
export const Scores = Schema.Struct({
    confidence: Schema.Number,
    label: Schema.String,
});
export const PredictionInput = Schema.Struct({
    text: Schema.String,
    skill: Schema.String,
});
export const PredictionResponse = Schema.Struct({
    skill: Schema.String,
    scores: Schema.Array(Scores),
    confidence: Schema.String,
    confidence_percent: Schema.Number,
});
export const BatchPredictionResponse = Schema.Struct({
    responses: Schema.Array(PredictionResponse),
});
export const BatchPredictionInput = Schema.Struct({
    requests: Schema.Array(PredictionInput),
});
